export default{
  receipts: (state) => state.receipts,
  receipt: (state) => state.receipt
}



// WEBPACK FOOTER //
// ./src/components/receipt/store/getters.js